//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamGrafObsah.ts						</Name>
//    <Description> Dialog seznam licencí										</Description>
//    <Author>      ffiala													</Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019							</Copyright>
//    <Created>     2019-02-20													</Created>
//  </FileHeader>

// experiment se seznamovým oknem, které pro vybudování využívá rodicovské třídy
// SeznamGrafObsahDesigner - strojně generovaná třída, která hlavně bude definovat políčka filtru a sloupce seznamu
// SeznamBase - obecný rodic včech seznamových oken

namespace Gordic.Adm.WebControls {

	const { gcontent } = Decorators;

	/** dialog seznamu  */
	@gcontent
    export class SeznamGrafObsah extends GContentBase<SeznamGrafObsahDesigner>  {

		//#region *** onContentReady && Init ***

        /** data definice grafu */
        private data: Gordic.AdmIsl.Interface.GGrafDefiniceDto;

		/** onContentReady */
        public onContentReady(): void {
            this.init();
		}

		/** init content */
        private init() {

            // inicializace hodnot od rodice
            SeznamGrafObsahDesigner.SeznamGrafObsahDesignerInit(this);

			this.setTitle();
			this.createMenuButtons();
            this.createGrid();
            this.createMenuBar();
			this.createSidebar();
		}

		/** nastavit titulek dialogu */
		private setTitle() {
                this.title = "jres:32131103" + " " + this.ixs_grf	//RC 32131103 : Obsah grafu
		}

		//#endregion

		//#region *** menubar ***

		private createContextBar(): MenuParams[] {
			var bar = this.setMenuButtons();
			return bar;
		}

		/**
		 * createMenuButtons
		 */
        private createMenuButtons(): void {
            // nic
		}

		/**
		 * vytvořit menu
		 */
		private createMenuBar(): void {
			this.menuBar(this.setMenuButtons());
		}

		private setMenuButtons(): MenuParams[] {

			const bar: MenuParams[] = [];

			return bar;
        }



		//#endregion

		//#region *** detail ***

		/**
		 * otevřít detail
		 */
        private openDetail(_new?: boolean): void {

            // neni

		}

		//#endregion

		//#region *** grid ***

		/** vytvořit seznam - definice objektu GRIDu, navázaných událostí atd... */
		private createGrid(): void {

            this.grid = $("<div>").gautofit().appendTo(this.element);

			this.grid.ggrid({
				data: this.view,
				name: "gridSeznam",
				renderMode: "auto",										// auto, all-at-once, paged-sync, paged-async
				columnMode: "full",										// fit (defaultne by melo byt toto), full
				customClass: "ts-grid-seznam-class",
				navigationMode: "row",									// row, cell
				//defaultAction: new GAction({							//obsluzna akce, ktera se spousti dbl clickem nad radkem
				//	name: "doubleClickGridSeznam",
				//	run: (ev, ctx) => {
				//		this.openDetail();
				//	}
				//}),
				searchColumns: this.gridSearchColumns,
				columns: this.gridFormat,
				contextMenu: this.createContextBar(),					// contextové menu
                sort: "dat_od",									    // řazení seznamu 
				selection: (ev, obj) => {
                    this.row = obj.getSelection();
                    this.refreshPanel();
                    this.refreshPanelGraph();
				}
			});

		}

		//#endregion

		//#region *** sidebar ***

		/** vytvořit sidebar */
		private createSidebar() {
            this.removeSidebar();

            var panel = this.createPanel();
            var panelGraph = this.createPanelGraph();

			this.sidebar = $(this.element).gsidebar({
				userSettings: this.userSettings,
				right: {
					pinned: true,
                    panels: [panel, panelGraph]
				}
			});
		}

		/** odstranit sidebar */
		private removeSidebar() {
			if (this.sidebar !== undefined) {
				this.sidebar.gsidebar("removeAll");
			}
		}

		/**  vytvořit panel */
		private createPanel(): GSideBarPanelOptions {
			this.panelId = "panelNahledSeznam";
			let panel = {
				minWidth: 300,
				id: this.panelId,
				caption: "jres:32131038",							//RC 32131038 : Náhled
                leaf: "jres:32131038",								//RC 32131038 : Náhled
                icon: "gi-nahled",
				open: (ev, obj) => {
					this.refreshPanel($(ev.target))
				},
			} as GSideBarPanelOptions;
			return panel;
		}

		/** refresh panelu */
		private refreshPanel(elementPanel?: JQuery<HTMLElement>): void {

			var panel: JQuery<HTMLElement> | undefined;

			if (this.closed) {		// ošetření zavření contentu
				return;
			}

			if (this.sidebar !== undefined) {
				panel = this.sidebar.gsidebar("getPanel", this.panelId);
			}
			else {
				panel = elementPanel;
			}
			if (panel !== undefined) {
				if (this.panelElement !== undefined) {
					this.panelElement.remove();
				}
				this.panelElement = $("<div>").appendTo(panel);
				GridUtils.setPanelGrid("jres:32131039", this.row, this.gridFormat, this.panelElement); //RC 32131039 : Seznam
			}
		}

		//#endregion

        /** Id panel grafu v sidebaru */
        private panelGraphId: string;

        /**  vytvořit panel s grafem */
        private createPanelGraph(): GSideBarPanelOptions {
            this.panelGraphId = "panelGraph";
            let panel = {
                minWidth: 300,
                id: this.panelGraphId,
                caption: "jres:32131091",							//RC 32131091 : Graf
                leaf: "jres:32131091",								//RC 32131091 : Graf
                icon: "gi-graph",
                open: (ev, obj) => {
                    this.refreshPanelGraph($(ev.target));
                },
            } as GSideBarPanelOptions;
            return panel;
        }

        private refreshPanelGraph(elementPanel?: JQuery<HTMLElement>) {

            var panel: JQuery<HTMLElement> | undefined;

            if (this.closed) {		// ošetření zavření contentu
                return;
            }

            if (this.sidebar !== undefined) {
                panel = this.sidebar.gsidebar("getPanel", this.panelGraphId);
            }
            else {
                panel = elementPanel;
            }

            if (panel !== undefined) {
                if (this.panelElement !== undefined) {
                    this.panelElement.remove();
                }
                this.panelElement = $("<div>").appendTo(panel);
                this.createGraph(this.panelElement);
            }

        }

        private createGraph(element: JQuery<HTMLElement>) {

            /**
             * seřadit dle data
             * @param a
             * @param b
             */
            function compare(a, b) {
                var a_dat_od = new Date(a.dat_od)
                var b_dat_od = new Date(b.dat_do)

                //var a_dat_od = (moment(a.dat_od!) as any)._d;
                //var b_dat_od = (moment(b.dat_od!) as any)._d;

                if (a_dat_od < b_dat_od) {
                    return -1;
                }
                if (a_dat_od > b_dat_od) {
                    return 1;
                }
                return 0;
            }

            // nemáme prázdný seznam
            if (this.row != null) {

                var rows = this.view.getDataRows();
                var data: any = [];
                var data2: any = [];

                rows = rows.sort(compare);

                for (var index = 0; index < rows.length; index++) {
                    var row = rows[index];
                    //var dat_od = (moment(row.dat_od!) as any)._d;
                    if (row.dat_od) {
                        var dat_od = new Date(row.dat_od as any);
                        data.push({
                            "date": dat_od,
                            "value": parseFloat((row as any).grf_sum)
                        });
                        data2.push({
                            "date": dat_od,
                            "value": row.grf_count
                        });
                    }
                }

                var config = {
                    marginTop: 50,
                    marginRight: 50,
                    marginBottom: 100,
                    marginLeft: 100,
                    displayLabels: true,
                    xAxis: "jres:32000128 " + this.data.jednotky_sum, //RC 32000128 : Suma        //todo: až to peťa horsák opraví, tak otočit axisy
                    yAxis: "jres:32000129", //RC 32000129 : Datum
                    width: 800,
                    height: 800
                };

                var graphTextOne = $("<div>").appendTo(element);
                var Form = new Gordic.Forms.Form({ name: "formSum" });
                Form.addSection(this.data.popis_sum!);
                graphTextOne.gform("createFrom", Form);

                var graphOne = $("<div>").appendTo(element);
                var options: IGChartOptions = { type: "line", data: data, config: config };
                graphOne.gchart(options);

                var graphTextTwo = $("<div>").appendTo(element);
                var Form = new Gordic.Forms.Form({ name: "formCount" });
                Form.addSection(this.data.popis_count!);
                graphTextTwo.gform("createFrom", Form);

                var config2 = {
                    marginTop: 50,
                    marginRight: 50,
                    marginBottom: 100,
                    marginLeft: 100,
                    displayLabels: true,
                    xAxis: "jres:32131094 " + this.data.jednotky_count, //RC 32131094 : Počet //todo: až to peťa horsák opraví, tak otočit axisy
                    yAxis: "jres:32000129", //RC 32000129 : Datum
                    width: 800,
                    height: 800
                };

                var graphTwo = $("<div>").appendTo(element);
                var options2: IGChartOptions = { type: "line", data: data2, config: config2 };
                graphTwo.gchart(options2);

                //var barChart1: any[] = [];

                //barChart1.push({ "salesperson": "Bob", "sales": 1000 });
                //barChart1.push({ "salesperson": "Bob", "sales": 33000000 });
                //barChart1.push({ "salesperson": "Robin", "sales": 12000000 });
                //barChart1.push({ "salesperson": "Anne", "sales": 41000000 });
                //barChart1.push({ "salesperson": "Mark", "sales": 16000000 });

                //$("<div>").appendTo(element).gchart({
                //    data: data,
                //    type: "bar",
                //    config: {
                //        displayLabels: true,
                //        width: 500,
                //        height: 500,
                //        marginLeft: 60,
                //        marginBottom: 50,
                //        marginTop: 20
                //    }
                //});

            }

        }

	}

}